export default __webpack_public_path__ + "static/media/Group 12090.3454daaa.png";